import { SettingsAreaContext } from 'global/cnr/contexts/SettingsAreaContext';
import SearchInput from 'global/components/menus/SearchInput';
import { useContext, useState } from 'react';
import { Icon, Label } from 'semantic-ui-react';
import { AppSettingsContext } from '../../../cnr/contexts/AppSettingsContext';
import { FrameworkContext } from '../../../cnr/contexts/FrameworkContent';
import { _settingSourceTypes, ServiceWorkerContext } from '../../../cnr/contexts/ServiceWorkerContext';
import { iconColorTypes } from '../../../enums/settingsIconTypes';
import { _settingsFs, rootSettings_collection_sandbox } from '../../actions/getSettings';

const backIcon = {
  color: 'red', // 'grey'
  icon: 'delete', // 'arrow left'
}

/**
 * 
 * @param {object} props (sideMenu, iconLeft, iconLeftColor, title, rightMenuItemProps)
 * @returns The `Menu` for the header of the `SettingsArea`
 */
const SettingsAreaMenuHeader = (props) => {

  const { isGlobal, sideMenu, iconLeft, iconLeftColor, title, subCaption, subTimeStamp, subDisplayName, rightMenuItemProps, settingsSourceType } = props

  const _title = isGlobal ? 'App Settings' : 'Page Settings'

  // serviceWorkerContext
  const serviceWorkerContext = useContext(ServiceWorkerContext)
  const { serviceWorker_state } = serviceWorkerContext ?? {}
  const { useSwCache } = serviceWorker_state ?? {}

  // appSettingsContext
  const appSettingsContext = useContext(AppSettingsContext)
  const { appSettings_state, appSettings_handlers } = appSettingsContext ?? {}
  const { sandboxOn } = appSettings_state ?? {}

  const settingsAreaContext = useContext(SettingsAreaContext);
  const { settingsArea_state, settingsArea_handlers } = settingsAreaContext ?? {}
  const { menuAuthGroups } = settingsArea_state ?? {}

  // const _menuAuthGroups = useState(_.cloneDeep(menuAuthGroups))
  const [_menuAuthGroups, set_global_app] = useState(_.cloneDeep(menuAuthGroups))

  // frameworkContext
  const frameworkContext = useContext(FrameworkContext);
  const { framework_handlers } = frameworkContext ?? {}
  const { handleShow_appSidebar } = framework_handlers ?? {}

  const [showInfo, setShowInfo] = useState()
  const [showSearch, setShowSearch] = useState()

  const { icon: iconRight, handleUpdateAll, handleAllowGroupMenuSort, show: showRight, allowGroupMenuSort } = rightMenuItemProps ?? {}
  const { fullMobileWidth } = sideMenu ?? {}

  const rsc = sandboxOn ? rootSettings_collection_sandbox : _settingsFs.root

  const handleShowInfo = () => setShowInfo(!showInfo)
  const handleShowSearch = () => setShowSearch(!showSearch)

  const handleSettingsOn = () => {
    if (isGlobal) {
      framework_handlers.handleShow_frameworkLeft()
      // appSettings_handlers.handleToggle_settingsLeftOn()
    } else {
      framework_handlers.handleShow_frameworkRight()
      // appSettings_handlers.handleToggle_settingsRightOn()
    }
  }

  let ico = {
    name: null,
    color: 'grey'
  }

  switch (settingsSourceType) {
    case _settingSourceTypes.app:
      ico.name = 'setting'
      ico.color = 'blue'
      break;
    case _settingSourceTypes.database:
      ico.name = 'database'
      ico.color = 'blue'
      break;
    case _settingSourceTypes.cache:
      ico.name = 'check circle'
      ico.color = 'green'
      break;
  }

  const div_info = () => <div className='top-info'>
    <Label color={iconColorTypes.settingsUser} className={sandboxOn ? 'blink_me_2' : null}>
      {<Icon name="database" color={useSwCache ? 'green' : 'black'} />}
      {rsc + ': ' + subCaption}
    </Label>
    {subTimeStamp && <Label color={ico.color}  >
      <Icon name="clock outline" color='black' />
      {subTimeStamp}
    </Label>}
    {subDisplayName && <Label color={'blue'}  >
      <Icon name="user outline" color='black' />
      {subDisplayName}
    </Label>}
  </div>

  const handleResults = (res) => settingsArea_handlers.handleAmmend_menuAuthGroups(res.results)

  const div_search = () => <div className='top-search'>
    <SearchInput searchType={'groupedItems'} data={_menuAuthGroups} handleResults={handleResults} useDeepSearch={true} />
  </div>

  // const menuItem_right = () => <Menu.Menu position='right'>
  //   {fullMobileWidth && <Menu.Item onClick={handleShow_appSidebar}>
  //     <Icon name={'delete'} />
  //   </Menu.Item>}
  //   {showRight && <Menu.Item onClick={handleUpdateAll}>
  //     <Icon name={iconRight} />
  //   </Menu.Item>}
  // </Menu.Menu>

  // const menuItem_edit = () => <Menu.Menu className={'samhe'} position='right'>
  //   <Menu.Item onClick={handleAllowGroupMenuSort}>
  //     <Icon name={'sort'} color={allowGroupMenuSort ? 'blue' : null} />
  //   </Menu.Item>
  // </Menu.Menu>

  // const menuItem_search = () => <Menu.Menu className={'samhe'}  >
  //   <Menu.Item onClick={settingsMenu_handlers.handleShowQuickSearch}>
  //     <Icon name={'caret down'} size={'large'} color={iconLeftColor} />
  //   </Menu.Item>
  // </Menu.Menu>

  // handleSettingsOn will turn on/off the settings view
  const div_iconTitle = () => <div className='top-title'>
    <div>
      <Icon.Group onClick={handleSettingsOn}>
        <Icon name={iconLeft} size={'large'} color={iconLeftColor} />
        <Icon corner='bottom left' name={backIcon.icon} size='tiny' color={backIcon.color} />
      </Icon.Group>
    </div>
    <div>{title ? title : _title}</div>
  </div>

  const div_icons = () => <div className='top-icons'>
    <Icon name={'info circle'} color={showInfo ? iconLeftColor : 'grey'} onClick={handleShowInfo} />
    {isGlobal && <Icon name={'search'} color={showSearch ? iconLeftColor : 'grey'} onClick={handleShowSearch} />}
  </div>

  const menu_div = () => <div className='menu-header-top'>
    {div_iconTitle()}
    {div_icons()}
    {showInfo && div_info()}
    {showSearch && div_search()}
  </div>

  return menu_div()

}

export default SettingsAreaMenuHeader